module.exports = __webpack_public_path__ + "static/media/ares128.c99ab8a8.png";